import React from "react";
import {TitleLayout} from "~/apps/core/ui/TitleLayout";
import {CreateOrderForm} from "~/apps/packages/auto-shipment-orders/components/CreateOrderForm/CreateOrderForm";
import {useCurrentCarrierId} from "~/apps/packages/auto-visits/hooks";
import {BrandAppBar} from "~/apps/core/ui/BrandAppBar";
import {Box, Container} from "@mui/material";
import {OrderCreateResult} from "~/apps/packages/auto-shipment-orders/components/OrderCreateResult";
import {useHistory} from "react-router-dom";


export const CreatePage = () => {
    const [carrierId] = useCurrentCarrierId();
    const history = useHistory();
    const handleContinueClick = () => {
        history.goBack();
    }

    const handleBrandClick = () => {
        history.push("/");
    }

    if (false) {
        return (
            <>
                <BrandAppBar onBrandClick={handleBrandClick}/>
                <Box marginTop="72px"/>
                <Container
                    sx={{
                        paddingTop: 0,
                        paddingBottom: 0,
                    }}
                >
                    <OrderCreateResult onContinue={handleContinueClick} />
                </Container>
                </>
        )
    }

    return (
        <TitleLayout title="Создание наряда" disableGutters>
            <CreateOrderForm carrierId={carrierId} />
        </TitleLayout>
    )
}
